import { LOGIN_FAIL, LOGIN_SUCCESS, LOGOUT } from "../actions/actionType";

const initialState = {
  user: {},
  isAuthenticated: false,
  token: "",
};

export const login = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN_SUCCESS:
      state = {
        ...state,
        user: { ...payload?.user },
        isAuthenticated: true,
        token: payload?.token,
      };
      return state;
    case LOGIN_FAIL:
      state = { user: {}, isAuthenticated: false, token: "" };
      return state;
    case LOGOUT:
      state = { ...state, user: {}, isAuthenticated: false, token: "" };
      return state;
    default:
      return state;
  }
};
